import Stocktakes from './Stocktakes';
export default Stocktakes;
